export default "__VITE_ASSET__DBUpGCwX__"